import React, { PureComponent } from 'react';
import RecordBinderHelper from '@progressivebeef/shared/src/helpers/RecordBinderHelper';
import './style.scss';
import { getLocale } from '@progressivebeef/shared/src/services/storageService/GlobalData';
import localization from '@progressivebeef/shared/src/localization/i18n';
import { RECORD_BINDER_STATUS } from '@progressivebeef/shared/src/constants/AppConstants';
import AssetConstants from '@progressivebeef/shared/src/constants/AssetConstants';

class RecordBinderCard extends PureComponent {
  render() {
    const { item, title, isHistory, onCardPress } = this.props;
    const expiryColor = RecordBinderHelper.getExpiryDateColor(
      item.expiry_date_color,
    );
    const formattedExpiryDate = RecordBinderHelper.formatExpiryDate(
      item.expiry_date,
    );
    let historyExpiry = null;
    if (isHistory) {
      historyExpiry = RecordBinderHelper.getHistoryExpiryStatus(
        item.expiresOn,
        localization[getLocale()],
      );
    }
    const sops = item.sops?.slice(0, 2) || [];
    const additionalSOPsCount = (item.sop_count || 0) - 2;
    const uploadedDate = item.updateDatetime;

    return (
      <div
        className="record-binder-card"
        onClick={() => onCardPress && onCardPress(item)}>
        <div className="parent-flex-box">
          <div className="icon-box">
            <img src={AssetConstants.recordFile} alt="file icon" />
          </div>
          <div className="info-box">
            <div className="title-row">
              <div className="main-title">{title || item.record_name}</div>
              {/* Either record status Archived or record is Expired and admin
              status is Archived */}
              {(item.status === RECORD_BINDER_STATUS.ARCHIVED ||
                (item.status === RECORD_BINDER_STATUS.EXPIRED &&
                  item.admin_status === RECORD_BINDER_STATUS.ARCHIVED)) && (
                <div className="archived-pill">
                  {localization[getLocale()].ARCHIVED}
                </div>
              )}
            </div>
            <div className="key-info-box">
              {isHistory ? (
                <>
                  {historyExpiry ? (
                    <div
                      className={`expiry-date expiry-${historyExpiry.color}`}>
                      {historyExpiry.date}
                    </div>
                  ) : null}
                  <div className="records-info records-info--right">
                    {uploadedDate && (
                      <span className="records-item">
                        {localization[getLocale()].UPLOADED_ON}{' '}
                        {RecordBinderHelper.formatExpiryDate(uploadedDate)}
                      </span>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div className="records-info">
                    {sops.length > 0 ? (
                      <>
                        {sops.map((sop, index) => (
                          <span key={index} className="records-item">
                            {sop.sop_number}
                            {index < sops.length - 1 && ', '}
                          </span>
                        ))}
                        {additionalSOPsCount > 0 && (
                          <span className="records-counter">
                            +{additionalSOPsCount} more
                          </span>
                        )}
                      </>
                    ) : null}
                  </div>
                  {formattedExpiryDate && (
                    <div
                      className={`expiry-date ${item.status === RECORD_BINDER_STATUS.EXPIRED ? 'expiry-deep-red' : `expiry-${expiryColor}`}`}>
                      {item.status === RECORD_BINDER_STATUS.EXPIRED
                        ? localization[getLocale()].EXPIRED
                        : `${localization[getLocale()].EXPIRES_ON} ${formattedExpiryDate}`}
                    </div>
                  )}
                  {/* When document is expired and it is in bin don't show date, although it stayed there for 3 years period */}
                  {!formattedExpiryDate &&
                    item.status === RECORD_BINDER_STATUS.BIN && (
                      <div className="expiry-date expiry-deep-red">
                        {localization[getLocale()].EXPIRED}
                      </div>
                    )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RecordBinderCard;
